import { gql } from '__generated__';

export default gql(`
  mutation TogglePublishTicketNumbers($input: ToggleEventSettingInput!) {
    togglePublishTicketNumbers(input: $input) {
      id
      ticket_numbers_published
    }
  }
`);
